import React, { useState } from 'react';
import QrScanner from '../Components/QRScanner';

const ScannerQr = () => {
  const [resultado, setResultado] = useState('');

  const handleScanSuccess = (data) => {
    setResultado(data);
    alert(`Código escaneado: ${data}`);
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Escáner de QR</h1>
      <QrScanner onScanSuccess={handleScanSuccess} />
      {resultado && (
        <p className="mt-4 text-green-600 font-medium">Resultado: {resultado}</p>
      )}
    </div>
  );
};

export default ScannerQr;
